<script lang="ts">
  import { HttpPromiseWithEntireResponse } from "@shared/svelte/Modules/ApiService";
  import type { RetailerIndexType } from "@shared/types/Retailer";
  import type { SalesRep } from "@shared/types/SalesRep";
  import moment from "moment";
  import Flash from "@shared/services/flashv2.js";
  import Large from "@shared/svelte/Components/Pagination/Large.svelte";
  import type { PaginationDetails } from "@shared/types/Pagination";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import { onMount } from "svelte";

  export let salesRep: SalesRep;
  export let assigned: boolean;
  let retailers: RetailerIndexType[] = [];
  let page = 1;
  let pagination: PaginationDetails = {
    page,
    perPage: 20,
    goToPage: number => {
      page = number;
      pagination.page = page;
      fetchRetailers();
    },
    totalEntries: 0,
    showTotals: false,
  };

  const fetchRetailers = async () => {
    try {
      const res = await HttpPromiseWithEntireResponse({
        method: "GET",
        url: "/api/distributor/retailers",
        data: { page: pagination.page, sales_rep_id: salesRep.id },
      });
      retailers = await res.json();
      pagination.totalEntries = parseInt(res.headers.get("X-Pagination-Entries"));
      pagination.perPage = parseInt(res.headers.get("X-Pagination-Limit"));
    } catch (_) {
      Flash.now({ type: "error", message: "There was an error fetching the retailers." });
    }
  };
  onMount(() => fetchRetailers());

  const lastOrderedAt = (date: string) => {
    // @ts-ignore
    return date ? moment(date, "YYYYMMDD").fromNow() : "--";
  };
  const removeRetailer = async (retailerId: number) => {
    try {
      const res = await HttpPromiseWithEntireResponse({
        method: "POST",
        url: "/api/distributor/sales_rep_assignments/destroy",
        data: { sales_rep_id: salesRep.id, retailer_id: retailerId },
      });
      if (!res.ok) throw res.json();
      Flash.now({ type: "success", message: "We have removed this account from this sales rep." });
    } catch (_) {
      Flash.now({ type: "error", message: "That didn't work at all - please contact support!" });
    }
  };
</script>

<div id="retailers">
  <table class="fizz-table fizz-stack-12">
    <thead>
      <tr>
        <th>Account number</th>
        <th>Retailer name</th>
        <th>Last order</th>
        <th>Order day</th>
        <th>Total orders</th>
        {#if assigned}
          <th>Remove</th>
        {/if}
      </tr>
    </thead>
    <tbody>
      {#each retailers as retailer}
        <tr>
          <td data-label="Account number">{retailer.account_number || "--"}</td>
          <td data-label="Retailer name">{retailer.name}</td>
          <td data-label="Last order">{lastOrderedAt(retailer.last_ordered_at)}</td>
          <td data-label="Order day">{retailer.order_day || "--"}</td>
          <td data-label="Total orders">{retailer.num_orders}</td>
          {#if assigned}
            <td data-label="Remove">
              <button
                class="fizz-icon-button-small"
                id="remove-assignment-{retailer.id}"
                on:click={() => removeRetailer(retailer.id)}
              >
                <Icon type="X" height="14" width="14" />
              </button>
            </td>
          {/if}
        </tr>
      {/each}
    </tbody>
  </table>
  <Large {pagination} />
</div>
